
import { computed, ComputedRef, defineComponent, PropType } from "vue";
import { Course } from "../../../../domain/entities/entities";
import {useRouter} from "vue-router";

const __default__ = defineComponent({
  name: "NewCourse",
  props: {
    course: {
      type: Object as PropType<Course>,
      required: true
    }
  },
  setup(props) {
    const router = useRouter();

    const backgroundImage: ComputedRef<string> = computed(() => {
      return `url(${props.course.imageURL})`;
    });

    const goToCourse = async () => {
      await router.push({ name: 'course', params: { course_id: props.course.id } })
    }

    return {
      backgroundImage,
      goToCourse,
    };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "acbabb28": (_ctx.backgroundImage)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__